import { ContentText, TitleTour } from "../components/ReactourComponents/styles"
import React from "react"

export const stepsTableClients = [
    {
        selector: "#table",
        content: () => (
            <div>
                <TitleTour>Clientes</TitleTour>
                <ContentText>Na tabela você pode observar as informações do cliente.</ContentText>
            </div>
        ),
    },
    {
        selector: "#filter-table",
        content: () => (
            <div>
                <TitleTour>Clientes</TitleTour>
                <ContentText>Digitando no campo de busca, você pode filtrar os clientes.</ContentText>
            </div>
        ),
    },
    {
        selector: "#export-button-table",
        content: () => (
            <div>
                <TitleTour>Clientes</TitleTour>
                <ContentText>Clicando no botão "Exportar Dados", será baixado um arquivo CSV com toda sua base de clientes.</ContentText>
            </div>
        ),
    }, 
    {
        selector: "#add-button-table",
        content: () => (
            <div>
                <TitleTour>Clientes</TitleTour>
                <ContentText>Clicando no botão "Adicionar Cliente", será será aberto um formulário lateral.</ContentText>
            </div>
        ),
        action: () => {
            document.getElementById("add-button-table")?.click()
        },
    },
    {
        selector: "#form-inputs",
        content: () => (
            <div>
                <TitleTour>Clientes</TitleTour>
                <ContentText>Preencha todas os campos, somente o complemento do endereço é opcional</ContentText>
            </div>
        ),
    },
    {
        selector: "#button-submit",
        content: () => (
            <div>
                <TitleTour>Clientes</TitleTour>
                <ContentText>Clique no botão e aguarde a confirmação do cadastro</ContentText>
            </div>
        ),
    },
]

export const stepsTypeClientRegister = [
    {
        selector: "#first-step",
        content: () => (
            <div>
                <TitleTour>Novidade</TitleTour>
                <ContentText>Agora você pode escolher qual o tipo de cliente a ser cadastrado, pessoa física ou jurídica.</ContentText>
            </div>
        ),
    }
]

export const stepGenTokenCardLink = [
    {
        selector: "#first-step",
        content: () => (
            <div>
                <TitleTour>Novidade</TitleTour>
                <ContentText>Agora você pode gerar um link para o seu cliente cadastrar(tokenizar) o cartão dele.</ContentText>
            </div>
        ),
    },
    {
        selector: "#dropdown",
        content: () => (
            <div>
                <TitleTour>Ícone de "mais"</TitleTour>
                <ContentText>Clique no botão de "mais" para exibir as opções de ações.</ContentText>
            </div>
        ),
        action: () => {
            document.getElementById("dropdownMenuButton-dropdown")?.click()
        },
    },
    {
        selector: "#dropdown-menu-dropdown",
        content: () => (
            <div>
                <TitleTour>Opções</TitleTour>
                <ContentText>E em seguida em "Adicionar novo cartão".</ContentText>
            </div>
        ),
    },
    {
        selector: "#modal-body",
        content: () => (
            <div>
                <TitleTour>Envie para seu cliente</TitleTour>
                <ContentText>Você pode enviar por email, whatsapp ou copiar o link e mandar para seu cliente.</ContentText>
            </div>
        ),
        action: () => {
            document.getElementById("generate-option-view")?.click()
        },
    },
]